<template>
  <el-dialog :title="$t('mainCategory.add')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addMainCategoryInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('mainCategory.categoryName')" prop="categoryName">
        <el-input v-model="addMainCategoryInfo.categoryName" :placeholder="$t('mainCategory.inputCategoryName')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.startTime')" prop="startTime">
        <el-date-picker v-model="addMainCategoryInfo.startTime" type="datetime"
          :placeholder="$t('mainCategory.selectStartTime')" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.endTime')" prop="endTime">
        <el-date-picker v-model="addMainCategoryInfo.endTime" type="datetime"
          :placeholder="$t('mainCategory.selectEndTime')" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.seq')" prop="seq">
        <el-input v-model.number="addMainCategoryInfo.seq" :placeholder="$t('mainCategory.inputSeq')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.desc')" prop="categoryDesc">
        <el-input v-model="addMainCategoryInfo.categoryDesc" type="textarea"
          :placeholder="$t('mainCategory.inputDesc')" />
      </el-form-item>

      <!-- 2026-07-03 新增：专区兜底商品匹配规则配置 -->
      <el-form-item label="匹配类型" prop="matchType">
        <el-select v-model="addMainCategoryInfo.matchType" placeholder="请选择匹配类型" style="width: 100%">
          <el-option label="全部商品" value="ALL" />
          <el-option label="商品分类" value="CATEGORY" />
          <el-option label="商品标签" value="LABEL" />
          <el-option label="店铺" value="SHOP" />
        </el-select>
      </el-form-item>
      <el-form-item label="匹配值" prop="matchValue">
        <el-input v-model="addMainCategoryInfo.matchValue" placeholder="多个值用英文逗号分隔，例如：1001,1002"
          :disabled="addMainCategoryInfo.matchType === 'ALL'" />
      </el-form-item>
      <el-form-item label="排序类型" prop="sortType">
        <el-select v-model="addMainCategoryInfo.sortType" placeholder="请选择排序类型" style="width: 100%">
          <el-option label="销量降序" value="SALES_DESC" />
          <el-option label="最近上架" value="NEW" />
          <el-option label="价格升序" value="PRICE_ASC" />
          <el-option label="价格降序" value="PRICE_DESC" />
          <el-option label="综合排序" value="COMPREHENSIVE" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveMainCategoryInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveMainCategory } from '@/api/admin/mainCategory/mainCategoryApi'

/**
 * 新增专区目录弹窗
 * 2026-07-03 新增 matchType、matchValue、sortType 字段配置
 */
export default {
  name: 'AddMainCategory',
  data() {
    return {
      dialogVisible: false,
      addMainCategoryInfo: {
        categoryName: '',
        startTime: '',
        categoryType: '2',
        endTime: '',
        seq: '',
        categoryDesc: '',
        // 2026-07-03 新增：兜底商品匹配规则默认值
        matchType: 'ALL',
        matchValue: '',
        sortType: 'SALES_DESC'
      },
      rules: {
        categoryName: [
          { required: true, message: this.$t('mainCategory.categoryNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('mainCategory.categoryNameTooLong'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('mainCategory.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('mainCategory.endTimeRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('mainCategory.seqRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('mainCategory.seqMustNumber'), trigger: 'blur' }
        ],
        categoryDesc: [
          { required: true, message: this.$t('mainCategory.descRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('mainCategory.descTooLong'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async saveMainCategoryInfo() {
      try {
        await this.$refs.form.validate()
        // 2026-07-03 新增：ALL 类型时清空匹配值，避免脏数据
        if (this.addMainCategoryInfo.matchType === 'ALL') {
          this.addMainCategoryInfo.matchValue = ''
        }
        await saveMainCategory(this.addMainCategoryInfo)
        this.$message.success(this.$t('mainCategory.addSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
